import { TestList } from "../../../components/tests/TestList.js";
import { useChapterContext } from "./useChapterContext.js";
import { EmptyState, useT } from "@mmm/ui";
/** The chapter's AI tests — the subject's tests filtered to this chapter.
 * Tests are AI-generated only; there is no manual test creation. */
export function ChapterTestsTab() {
  const { subject, chapter } = useChapterContext();
  const t = useT();

  const tests = subject.aiTests.filter((test) => test.chapterIds?.includes(chapter.id) ?? test.chapterId === chapter.id);

  return (
    <div>
      {tests.length === 0 ? (
        <EmptyState title={t("tests.noneForChapter")} message={t("tests.noneForChapterHint")} />
      ) : (
        <TestList tests={tests} subjectId={subject.id} />
      )}
    </div>
  );
}
